module.exports = __webpack_public_path__ + "img/drifter-zone-wechat-desktop.f0a3e70.png";